export default function filterOutDeletedPolicyCategories(policies, categories = []) {
    const categoryIds = categories.map((cat) => cat.id);
    const isCatIdRelevant = (catId) => categoryIds.includes(catId);

    policies.forEach(({ policy }) => {
        if (policy.isolatedCategories) {
            policy.isolatedCategories = policy.isolatedCategories.filter(isCatIdRelevant);
        }

        policy.contentFiltering.forbiddenCategories = policy
            .contentFiltering
            .forbiddenCategories
            .filter(isCatIdRelevant);
    });
}
